// extracted by mini-css-extract-plugin
export var scheme = "ImgSection-module--scheme--e6e34";
export var section = "ImgSection-module--section--56887";